import React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';

function MoveableWrapper(props: IBaseComponentProps<HTMLDivElement>) {
    const { className, elementRef } = props;
    return (<div ref={elementRef} className={`${className} ap-popup-moveableWrapper`} />);
}

export const StyledMoveableWrapper = styled(MoveableWrapper)`
    width: calc(100% - 30px);
    height: 15px;
    position:absolute;
    top:0px;
    cursor: move;
`;
